import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'sonner';
import { APP_LOGO_PUBLIC_SRC, TITLE_HEADING_NAME } from './config/branding';

document.title = TITLE_HEADING_NAME;
document.querySelectorAll("link[rel*='icon']").forEach((link) => {
  link.href = APP_LOGO_PUBLIC_SRC;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
